/* Flex Factory - luxe layer behaviour: header, mobile menu, scroll reveals,
   mobile shop bar, homepage quick builder and studio deep links.
   Everything here is additive: it reads and clicks the existing studio
   controls rather than replacing them, so pricing and checkout stay exactly
   as they were. */
(function () {
"use strict";
var d = document, w = window, RM = w.matchMedia && w.matchMedia("(prefers-reduced-motion: reduce)").matches;
function $(s, r) { return (r || d).querySelector(s); }
function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

/* ---------- header + menu ---------- */
function header() {
  var h = $("#lxHead"); if (!h) return;
  var onScroll = function () { h.classList.toggle("scrolled", w.scrollY > 8); };
  onScroll(); w.addEventListener("scroll", onScroll, { passive: true });
  var b = $(".lx-burger", h), m = $("#lxMenu");
  if (!b || !m) return;
  function set(on) {
    d.documentElement.classList.toggle("lx-open", on);
    b.setAttribute("aria-expanded", on ? "true" : "false");
    b.setAttribute("aria-label", on ? "Close menu" : "Open menu");
    d.body.style.overflow = on ? "hidden" : "";
  }
  b.addEventListener("click", function () { set(!d.documentElement.classList.contains("lx-open")); });
  m.addEventListener("click", function (e) { if (e.target.closest("a")) set(false); });
  d.addEventListener("keydown", function (e) { if (e.key === "Escape") set(false); });
  w.addEventListener("resize", function () { if (w.innerWidth > 900) set(false); });
}

/* ---------- reveals ---------- */
var REVEAL = ".sec-head,.card,.step,.faq details,.prod-grid figure,.watch-split,.cform,.gal>button:nth-child(-n+12)," +
  ".lh-head,.lh-line,.lh-steps li,.lh-honest h2,.lh-promises>div,.lh-final>*,.lx-foot-top>div";
function reveals() {
  if (RM || !("IntersectionObserver" in w)) return;
  var els = $$(REVEAL).filter(function (el) { return !el.closest(".lh-hero"); });
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
  els.forEach(function (el) {
    var sib = el.parentNode ? $$(":scope>[data-r]", el.parentNode).length : 0;
    el.setAttribute("data-r", "");
    el.style.setProperty("--d", Math.min(sib, 6) * 0.07 + "s");
    io.observe(el);
  });
  /* Elements added later (ff-app renders setting cards and FAQ after load). */
  setTimeout(function () {
    $$(REVEAL).forEach(function (el) { if (!el.hasAttribute("data-r") && !el.closest(".lh-hero")) { el.setAttribute("data-r", ""); io.observe(el); } });
  }, 1200);
}

/* ---------- homepage reel: play clips while on screen ---------- */
function reel() {
  var vids = $$(".lh-reel video[data-src]");
  if (!vids.length || !("IntersectionObserver" in w)) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.src) v.src = v.getAttribute("data-src");
        if (!RM) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else v.pause();
    });
  }, { threshold: 0.4 });
  vids.forEach(function (v) {
    v.addEventListener("playing", function () { v.classList.add("on"); });
    io.observe(v);
  });
}

/* ---------- mobile shop bar ---------- */
function bar() {
  var b = $("#lxBar"); if (!b) return;
  var foot = $(".lx-foot");
  function tick() {
    var past = w.scrollY > w.innerHeight * 0.7;
    var nearFoot = foot && foot.getBoundingClientRect().top < w.innerHeight;
    var on = past && !nearFoot && !d.documentElement.classList.contains("lx-open");
    b.classList.toggle("show", on);
    d.body.classList.toggle("has-bar", on && w.innerWidth <= 760);
  }
  tick(); w.addEventListener("scroll", tick, { passive: true }); w.addEventListener("resize", tick);
}

/* ---------- studio helpers ---------- */
var KEYS = { s: ["honeycomb", "galaxy", "mosaic", "baguette"], m: ["gold", "white", "rose"], a: ["upper", "lower", "both"], n: ["2", "4", "6", "8", "10"] };
var GROUP = { s: "#optSetting", m: "#optMetal", a: "#optArch", n: "#optCount",
  /* the homepage watch studio runs with its ids prefixed "w" */
  wd: "#woptStyle", wn: "#woptNum", wt: "#woptTone", ws: "#woptStone",
  /* and the G-Shock studio with "g" */
  gc: "#goptColour", gd: "#goptDesign", gf: "#goptFinish" };
var WKEYS = ["wd", "wn", "wt", "ws"];
var GKEYS = { gc: ["white", "black", "red"], gd: ["flame", "spike", "thorn", "rope", "cluster"] };
function opts(k) { var g = $(GROUP[k]); return g ? $$("button", g) : []; }
function pressed(k) { var b = opts(k); for (var i = 0; i < b.length; i++) if (b[i].getAttribute("aria-pressed") === "true") return i; return -1; }
function pick(k, i) { var b = opts(k); if (b[i] && b[i].getAttribute("aria-pressed") !== "true") b[i].click(); }
function whenStudio(cb) {
  var t = 0, iv = setInterval(function () {
    if (opts("s").length && opts("m").length) { clearInterval(iv); cb(); }
    else if (++t > 100) clearInterval(iv);
  }, 80);
}
function studioLink() {
  var q = [];
  ["s", "m", "a", "n"].forEach(function (k) { var i = pressed(k); if (i >= 0) q.push(k + "=" + KEYS[k][i]); });
  return "/pages/studio?" + q.join("&");
}

function watchLink() {
  var q = [];
  WKEYS.forEach(function (k) { var i = pressed(k); if (i >= 0) q.push(k + "=" + i); });
  return "/pages/watches?" + q.join("&") + "#watches";
}

function gLink() {
  var c = pressed("gc"), g = pressed("gd"), f = pressed("gf"), q = [];
  if (c >= 0) q.push("c=" + GKEYS.gc[c]); if (g >= 0) q.push("d=" + GKEYS.gd[g]); if (f >= 0) q.push("f=" + f);
  return "/pages/g-shock" + (q.length ? "?" + q.join("&") : "");
}

/* The G-Shock studio reads its own prefix, so it is loaded as it is. */
var gState = 0;
function loadG(cb) {
  if (gState === 2) return cb();
  if (gState === 1) return;
  var src = ($("[data-gsrc]") || { getAttribute: function () { return ""; } }).getAttribute("data-gsrc");
  if (!src || !w.THREE) return;
  gState = 1; w.FF_G_PREFIX = "g";
  var sc = d.createElement("script"); sc.src = src;
  sc.onload = function () { gState = 2; cb(); };
  sc.onerror = function () { gState = 0; };
  d.body.appendChild(sc);
}

/* Arriving from the homepage watch builder: /pages/watches?wd=2&wn=0&wt=1&ws=0#watches
   The values are button positions in the watch studio's own option lists. */
function watchDeepLink() {
  if (d.body.classList.contains("lx-home") || !$("#optStyle")) return;
  var p = new URLSearchParams(location.search), map = { wd: "#optStyle", wn: "#optNum", wt: "#optTone", ws: "#optStone" };
  if (!WKEYS.some(function (k) { return p.get(k) != null; })) return;
  var t = 0, iv = setInterval(function () {
    if (!$$("button", $("#optStyle")).length) { if (++t > 100) clearInterval(iv); return; }
    clearInterval(iv);
    WKEYS.forEach(function (k) {
      var i = parseInt(p.get(k), 10), b = $$("button", $(map[k]));
      if (i >= 0 && b[i] && b[i].getAttribute("aria-pressed") !== "true") b[i].click();
    });
  }, 80);
}

/* The watch studio script uses plain ids (#gl, #qPrice...) that the grillz
   studio also uses. On the homepage it is fetched and run with every id
   lookup prefixed "w", so both studios share the page and the watches page
   keeps running the file exactly as it is. */
var watchState = 0;
function loadWatch(cb) {
  if (watchState === 2) return cb();
  if (watchState === 1) return;
  var src = ($("[data-wsrc]") || { getAttribute: function () { return ""; } }).getAttribute("data-wsrc");
  if (!src || !w.fetch || !w.THREE) return;
  watchState = 1;
  fetch(src).then(function (r) { return r.text(); }).then(function (t) {
    t = t.split("document.getElementById(").join("$W(")
         .replace('"use strict";', '"use strict";\nfunction $W(id) { return document.getElementById("w" + id); }');
    var sc = d.createElement("script"); sc.textContent = t; d.body.appendChild(sc);
    watchState = 2; cb();
  }).catch(function () { watchState = 0; });
}

/* Arriving from the homepage builder: /pages/studio?s=galaxy&m=white&a=both&n=6 */
function deepLink() {
  if (d.body.classList.contains("lx-home") || !$("#optSetting")) return;
  var p = new URLSearchParams(location.search);
  if (!p.get("s") && !p.get("m") && !p.get("a") && !p.get("n")) return;
  whenStudio(function () {
    ["s", "m", "a", "n"].forEach(function (k) {
      var i = KEYS[k].indexOf(String(p.get(k) || "").toLowerCase());
      if (i >= 0) pick(k, i);
    });
    var build = $("#build"); if (build && /grillz/.test(location.pathname)) build.scrollIntoView({ block: "start" });
  });
}

/* ---------- homepage quick builder ---------- */
function quick() {
  if (!d.body.classList.contains("lx-home")) return;
  var builds = $$(".lh-build"), stage = $(".lh-stage");
  function txt(el) { return el ? el.textContent.replace(/\s+/g, " ").trim() : ""; }
  function render() {
    builds.forEach(function (root) {
      $$("[data-q]", root).forEach(function (box) {
        var k = box.getAttribute("data-q"), src = opts(k), on = pressed(k), dots = box.classList.contains("dots");
        if (!src.length) return;
        box.innerHTML = "";
        src.forEach(function (b, i) {
          var x = d.createElement("button"); x.type = "button";
          x.setAttribute("aria-pressed", i === on ? "true" : "false");
          var name = txt($(".s-nm", b)) || txt(b), meta = txt($(".s-meta", b)), sw = $(".s-sw", b);
          if (k === "a") name = name.replace("Top + bottom", "Both");
          if (dots) { x.title = name; x.setAttribute("aria-label", name + " numerals"); }
          x.innerHTML = (sw ? '<span><i class="lh-sw" style="background:' + sw.style.background + '"></i>' + name + "</span>" : "<span>" + name + "</span>") +
            ((k === "s" || k === "ws" || k === "gd") && meta ? "<small>" + meta + "</small>" : "");
          x.addEventListener("click", function () { pick(k, i); setTimeout(sync, 30); });
          box.appendChild(x);
        });
      });
    });
  }
  function stones(id) { var m = /([\d,]+)<\/b>\s*stones/.exec(($(id) || {}).innerHTML || ""); return m ? m[1] : ""; }
  function sync() {
    render();
    var watch = stage && stage.classList.contains("watch"), gs = stage && stage.classList.contains("gshock");
    var g = { price: txt($("#qPrice")), label: txt($("#qTeeth")), link: studioLink(), stones: stones("#readout") };
    var DOT = " " + String.fromCharCode(183) + " ", wl = txt($("#wqLabel")).split(DOT);
    var wv = { price: txt($("#wqPrice")) || "$750", link: watchLink(), stones: stones("#wreadout"),
      label: wl.length > 1 ? wl[0] + DOT + wl[wl.length - 1] : "Iced watch",
      full: wl.length > 1 ? wl.join(DOT) : "Loading the watch..." };
    var gl = txt($("#gqLabel")).split(DOT);
    var gv = { price: txt($("#gqPrice")) || "$302", link: gLink(), stones: stones("#greadout"),
      label: gl.length > 1 ? gl[0] + DOT + gl[1] : "Iced G-Shock",
      full: gl.length > 1 ? gl.join(DOT) : "Loading the G-Shock..." };
    function which(el) { return el.closest(".lh-gshock") ? gv : el.closest(".lh-watch") ? wv : el.closest(".lh-grillz") ? g : (gs ? gv : watch ? wv : g); }
    $$("[data-price]").forEach(function (el) { el.textContent = which(el).price; });
    $$("[data-label]").forEach(function (el) { var v = which(el); el.textContent = (v === wv && el.closest(".lh-watch")) || (v === gv && el.closest(".lh-gshock")) ? v.full : v.label; });
    $$("[data-studio]").forEach(function (el) { el.href = which(el).link; });
    $$("[data-stones]").forEach(function (el) { var n = which(el).stones; el.textContent = n || String.fromCharCode(8212); });
  }
  var wObs = false;
  function watchReady() {
    if (stage) stage.classList.add("wready");
    if (wObs) return sync();
    wObs = true;
    var ro = $("#wreadout");
    if (ro && w.MutationObserver) new MutationObserver(sync).observe(ro, { childList: true, subtree: true });
    sync();
  }
  var gObs = false;
  function gReady() {
    if (stage) stage.classList.add("gready");
    if (gObs) return sync();
    gObs = true;
    var ro = $("#greadout");
    if (ro && w.MutationObserver) new MutationObserver(sync).observe(ro, { childList: true, subtree: true });
    sync();
  }
  $$("[data-piece]").forEach(function (b) {
    b.addEventListener("click", function () {
      var watch = b.getAttribute("data-piece") === "watch", gs = b.getAttribute("data-piece") === "gshock";
      $$("[data-piece]").forEach(function (o) { o.setAttribute("aria-pressed", o.getAttribute("data-piece") === b.getAttribute("data-piece") ? "true" : "false"); });
      builds.forEach(function (r) { r.classList.toggle("watch", watch); r.classList.toggle("gshock", gs); });
      if (stage) { stage.classList.toggle("watch", watch); stage.classList.toggle("gshock", gs); }
      if (gs) loadG(function () {
        var t = 0, iv = setInterval(function () {
          if (opts("gd").length) { clearInterval(iv); gReady(); } else if (++t > 100) clearInterval(iv);
        }, 80);
      });
      if (watch) loadWatch(function () {
        var t = 0, iv = setInterval(function () {
          if (opts("wd").length) { clearInterval(iv); watchReady(); } else if (++t > 100) clearInterval(iv);
        }, 80);
      });
      sync();
    });
  });
  whenStudio(function () {
    sync();
    var ro = $("#readout");
    if (ro && w.MutationObserver) new MutationObserver(sync).observe(ro, { childList: true, subtree: true });
  });
}

function init() { header(); reveals(); reel(); bar(); deepLink(); watchDeepLink(); quick(); }
if (d.readyState === "loading") d.addEventListener("DOMContentLoaded", init); else init();
})();
